function injectCloseButton() {
  const el = document.querySelector('.R-LauncherButton');
  const reviewsBox = document.querySelector('.FloatingWidget .FloatingPanel__header');
  if (!el) return false;

  if (el.querySelector('.reviews-hack-close')) return true;

  const closeBtn = document.createElement('button');
  closeBtn.className = 'reviews-hack-close';
  closeBtn.type = 'button';
  closeBtn.setAttribute('aria-label', 'Close');
  closeBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" style="display:block" aria-hidden="true"><path d="M4.5 7.5l4.5 4.5 4.5-4.5" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  closeBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    el.click();
  });

  reviewsBox.appendChild(closeBtn);
  return true;
}

if (!injectCloseButton()) {
  const observer = new MutationObserver(function() {
    if (injectCloseButton()) {
      observer.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(function() { observer.disconnect(); }, 10000);
}
